import { BaseFieldView } from '../BaseField/views';

export const DatetimeFieldView = BaseFieldView.extend({
    picker_type: 'date', // Either date or datetime

    events: {
        'click .show_datetime_picker': 'show_picker' // Mobiscroll already takes care of this already for date field
    },

    onRender: function () {
        var this_ = this;

        this.picker_type = this.model.get('allow_time') ? 'datetime' : 'date';

        this.$el
            .find('.show_datetime_picker')
            .mobiscroll()
            [this.picker_type]({
                theme: 'material',
                display: 'bottom',
                defaultValue: this.model.get('value') ? new Date(this.model.get('value').$date) : undefined,
                max: new Date(new Date().getFullYear() + 10, 11, 31),
                min: new Date(1900, 1, 1),
                focusOnClose: false,
                dateWheels: 'M D d yy',
                onSet: function (event, inst) {
                    this_.save_value(inst.getVal());
                }
            });
    },

    show_picker: function (event) {
        this.$el.find('.date input').mobiscroll('show');
        return false;
    },

    save_value: function (new_datetime) {
        // If updating datetime to same value, render. Otherwise, set won't be called
        // and the view won't re-render with the correct datetime formatting.
        if (new_datetime.getTime() == this.model.get('value').$date) {
            this.render();
            return;
        }

        // if datetime convert to epoch and save
        // If just date, set the time to the end of the day selected
        // @todo: kgstew update these moment call to use $f.utils.end_of_day()
        this.model.set(
            'value',
            {
                $date:
                    this.picker_type == 'datetime'
                        ? new_datetime.getTime()
                        : moment(new_datetime).endOf('day').toDate().getTime()
            },
            { validate: true }
        );
    }
});
